import { makeStyles } from '@material-ui/styles';
import { colors } from '../../../style/colors';
import { ITheme } from '../../../style/theme';

interface StyleProps {
  hover: boolean;
  size?: 'small' | 'default';
}

export const useStyles = makeStyles<ITheme, StyleProps>((theme) => ({
  root: {
    position: 'relative',
    height: '192px',
    width: '800px',
    cursor: 'pointer',
    backgroundColor: colors.white,
    borderRadius: '16px',
    overflow: 'hidden',
    boxShadow: '0px 6px 12px rgba(27, 27, 28, 0.15)',
    '&:hover, &:focus': {
      boxShadow: '0px 8px 24px rgba(27, 27, 28, 0.15)',
    },
    [theme.breakpoints.down('md')]: {
      width: '312px',
      height: '348px',
    },
  },
  mentorShape: {
    position: 'absolute',
    left: 0,
    [theme.breakpoints.down('md')]: {
      bottom: 0,
    },
  },
  mentorImage: {
    position: 'absolute',
    width: 430,
    right: 0,
    [theme.breakpoints.down('md')]: {
      top: 0,
      width: 355,
    },
  },
  info: {
    position: 'absolute',
    left: 0,
    padding: 24,
    [theme.breakpoints.down('md')]: {
      bottom: 0,
      display: 'flex',
      flexDirection: 'column',
    },
  },
  cardButton: (props) => ({
    width: 'fit-content',
    backgroundColor: props.hover ? 'rgba(255, 255, 255, 0.2)' : 'transparent',
    color: 'white',
    height: 42,
    fontSize: 14,
    fontWeight: 'bold',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.2)',
    },
    '&:focus': {
      backgroundColor: 'rgba(255, 255, 255, 0.2)',
    },
    borderColor: 'white',
    borderRadius: 8,
  }),
  infoLabel: {
    color: colors.white,
    width: 338,
    paddingBottom: 24,
    [theme.breakpoints.down('md')]: {
      width: '100%',
      alignSelf: 'center',
    },
  },
  squareBanner: {
    height: '350px',
    width: '350px',
    '& $mentorShape': {
      height: '350px',
      width: '350px',
      top: 100,
      [theme.breakpoints.down('xs')]: {
        top: 65,
      },
    },
    [theme.breakpoints.down('xs')]: {
      width: '318px',
    },
    '& $info': {
      top: 165,
      width: 350,
      '& h4': {
        fontSize: 18,
        paddingRight: 20,
        lineHeight: '24px',
        [theme.breakpoints.down('md')]: {
          fontSize: 17,
        },
      },
      display: 'flex',
      flexDirection: 'column',
      [theme.breakpoints.down('xs')]: {
        top: 140,
        width: 318,
      },
    },
    '& $mentorImage': {
      width: 430,
    },
    '& $cardButton': {
      alignSelf: 'center',
    },
  },
}));
